import script from "./WidgetAuthorization.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetAuthorization.vue?vue&type=script&setup=true&lang=js"

import "./WidgetAuthorization.vue?vue&type=style&index=0&id=de9924d8&lang=scss"

const __exports__ = script;

export default __exports__